import { createContext, RefObject } from 'react';
import { FormMethodsInner } from './helps/form-store';
import { FormProps } from './types';
export type FormContextApi = {
  form: FormMethodsInner;
  onValuesChange?: FormProps['onValuesChange'];
  formRef: RefObject<HTMLDivElement>;
  scrollIntoView?: boolean;
  showErrorMessage?: boolean;
};
export const FormContext = createContext<FormContextApi>({} as FormContextApi);
